import { render, staticRenderFns } from "./ElectricalView.vue?vue&type=template&id=512d927d&"
import script from "./ElectricalView.vue?vue&type=script&lang=js&"
export * from "./ElectricalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports